const InvitationStatuses = Object.freeze({
  SENT: 1,
  RECEIVED: 2,
  REGISTERED: 3,
});

export default InvitationStatuses;
